import { Field } from 'formik';
import { FsProps, CustomSelectComponent, FormCol6 } from 'motion-components';
import React from 'react';

//1;field;technicianAssessment;enum('used','damaged','critically_damaged');;Αξιολόγηση από Τεχνίτη Υψηλής Τάσης;B.2;
export const FieldSelectPackagingCondition = ({
  label = 'Κατάσταση συσκευασίας;',
  name = 'xrbData.packagingCondition',
  as = 'div',
  ...rest
}: FsProps) => {
  const options = [
    { value: 'Άριστη', label: 'Άριστη' },
    { value: 'Καλή', label: 'Καλή' },
    { value: 'Με σημάδια φθοράς ή παραμόρφωσης', label: 'Με σημάδια φθοράς ή παραμόρφωσης' },
  ];
  return (
    <Field
      name={name}
      title={label}
      component={(props) => <CustomSelectComponent {...props} as={as} className="mb-0" />}
      options={options}
      useCreatableSelect={true}
      {...rest}
    />
  );
};
